import ImageMessage from "@frameworks/web/components/generic/Login/ImageMessage";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
import { Row, Col } from "react-bootstrap";
import unblock from "../../../../assets/images/generic/unblock.svg";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { useSelector } from "react-redux";
import di from "@frameworks/web/components/features/LoginFlow/di/servicelocator";
import { useNavigate } from "react-router-dom";
import { handleNavigateUrl, loginScreenState } from "../constant";
export const Msg = (accountID) => (React.createElement(React.Fragment, null,
    React.createElement("span", null,
        "Your account ",
        React.createElement("strong", null,
            "(",
            accountID,
            ")"),
        " has been unblocked.")));
const UnblockAccountMsg = (props) => {
    const device = DeviceContext();
    const navigate = useNavigate();
    const { data: unblockAccount } = useSelector((state) => state.LoginFlow.unblockUser);
    const backToLogin = () => {
        di.login.flushLoginReducers();
        if (props.helpFlowPopup) {
            props.helpFlowPopup(loginScreenState.LOGIN);
        }
        else {
            navigate(handleNavigateUrl("/login", props.redirectUrlFromQueryParams), {
                replace: true,
            });
        }
    };
    return (React.createElement("div", { className: "imageblockSection p-3 bg-white removecapitalize" }, (unblockAccount === null || unblockAccount === void 0 ? void 0 : unblockAccount.userID) && (React.createElement(Row, { className: "d-flex justify-content-center align-items-center" },
        React.createElement(Col, { lg: 12, className: "px-3 px-md-0" },
            React.createElement(ImageMessage, { title: (device === null || device === void 0 ? void 0 : device.isDesktop) ? " " : "Account Unblocked", image: unblock, message: Msg(unblockAccount === null || unblockAccount === void 0 ? void 0 : unblockAccount.userID) })),
        React.createElement(Col, { lg: 10, className: "mt-5 mb-5" },
            React.createElement(EdButton, { value: "Back to Login", className: "w-100 btn-18px", btnTyp: "midnight-blue", onClick: () => backToLogin() }))))));
};
export default UnblockAccountMsg;
